import PropTypes from 'prop-types';
import React, { useState } from 'react';

const ExpandableCard = ({ className, defaultExpanded, isCollapsible, renderHeader, children }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    if (!isCollapsible) return;
    setIsExpanded(prev => !prev);
  };

  return (
    <div className={className}>
      {renderHeader({ isExpanded, onToggle: handleToggle })}
      <div className='expandable-card-body-wrapper' data-open={isExpanded}>
        <div className='expandable-card-body-inner'>{children}</div>
      </div>
    </div>
  );
};

ExpandableCard.propTypes = {
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  isCollapsible: PropTypes.bool,
  renderHeader: PropTypes.func.isRequired,
  children: PropTypes.node,
};

ExpandableCard.defaultProps = {
  className: '',
  defaultExpanded: true,
  isCollapsible: true,
  children: null,
};

export default ExpandableCard;
